import React from 'react'
import "./FAQ.css"
import CompareCollegeFaq from '../../CompareCollegeFaq/CompareCollegeFaq'

function FAQ() {
  return (
    <>
  <CompareCollegeFaq />
    </>
  )
}

export default FAQ